import { useMemo } from 'react';

import groupBy from 'lodash/groupBy';

export const useSummable = series => {
  return useMemo(() => {
    const filteredSeries = series.filter(({ metric }) =>
      ['number', 'currency'].includes(metric.type)
    );

    const groups = groupBy(filteredSeries, ({ activityType, metric }) => {
      return `${activityType.id}___${metric.id}`;
    });

    return Object.keys(groups).reduce((summable, metricId) => {
      const group = groups[metricId];
      if (group.length > 1) {
        summable.push(group);
      }
      return summable;
    }, []);
  }, [series]);
};

export const useSum = series => {
  return useMemo(() => getMultiMetricSum(series), [series]);
};

function getMultiMetricSum(summableSeries) {
  if (!summableSeries.length) {
    return [];
  }

  return summableSeries.map(group => {
    const { metric, activityType, id } = group[0];
    let multiMetricSumObj = group.reduce((multiMetricSumObj, { values }) => {
      values.forEach(({ date, value, trend }) => {
        if (!multiMetricSumObj.hasOwnProperty(date)) {
          multiMetricSumObj[date] = { value: 0, trend: 0 };
        }
        multiMetricSumObj[date].value += value;
        multiMetricSumObj[date].trend += trend;
      });
      return multiMetricSumObj;
    }, {});

    const sortedDates = Object.keys(multiMetricSumObj).sort((a, b) => +a - b);

    const multiMetricSum = sortedDates.map(d => ({
      date: d,
      ...multiMetricSumObj[d],
    }));

    return {
      baseSeriesId: id,
      id: `${Math.random()}${+new Date()}`,
      metric,
      activityType,
      period: [sortedDates[0], sortedDates[sortedDates.length - 1]],
      values: multiMetricSum,
    };
  });
}
